import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { computed } from 'vue'
import { formatMoney } from '@/helpers/formatMoney'


export default /*#__PURE__*/_defineComponent({
  __name: 'Money',
  props: {
    value: null,
    estimate: { type: Boolean },
    hideZero: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    value: number | null
    estimate?: boolean
    hideZero?: boolean
};



const formatted = computed(() => {
    if (props.estimate && props.value !== null) {
        return '~ ' + formatMoney(Math.round(props.value / 100) * 100)
    }

    return formatMoney(props.value)
})

return (_ctx: any,_cache: any) => {
  return (__props.value !== null && (__props.value > 0 || !__props.hideZero))
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(formatted)), 1))
    : _createCommentVNode("", true)
}
}

})